import React from 'react';
import queryString from 'query-string';
import { Form, Progress } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = 'gnet';
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: ''
      },
      username: '',
      password: ''
    };
  }

  componentDidMount() {

    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message
      }
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: ''
      }
    });



    this.props.api.userPassLogin(
      {
        username: this.state.username.replace(/[^\d]/g, ''),
        password: this.passwordInput.value
      }, this.parameters
    )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location = this.parameters.redirect_uri + '?' + queryString.stringify(response);
      })
      .catch(error => {
        const translate = this.props.translate(error.errorCode);

        let message = 'Usuário e/ou senha inválidos';

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }

        this.setState({ onLogin: false, error: { open: true, message: message } });
      });
  }

  transformCPF = (value) => {
    if (value.length > 18) return this.state.username
    value = value.replace(/\D/g, "")
    value = value.replace(/(\d{3})(\d)/, "$1.$2")
    value = value.replace(/(\d{3})(\d)/, "$1.$2")
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2")

    if (value.length > 14) {
      value = value.replace(/\./g, '')
      value = value.replace(/^(\d{2})(\d)/, "$1.$2")
      value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      value = value.replace(/\.(\d{3})(\d)/, ".$1/$2")
      value = value.replace(/(\d{4})(\d)/, "$1-$2")
    }
    return value

  }

  render() {
    const { translate } = this.props;

    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
        <div ref={this.ref}>
          <Form onSubmit={event => this.onSubmit(event)}>
            <label className="label-gnet">CPF/CNPJ</label>
            <br />
            <div className='div-input'>
              <div className='icono'><i className="fa fa-lg fa-id-card-o " style={{ margin: 'auto', color: '#518AFF' }} /></div>
              <input
                className='form-control input-gnet'
                disabled={this.state.onLogin}
                onChange={(e) => {
                  const result = this.transformCPF(e.target.value)
                  this.setState({ username: result })
                }
                }
                value={this.state.username}
                required={true}
                tabIndex={1}
                type="text"
                autoCorrect="off"
                autoCapitalize="none"
                name="username"
                placeholder="CPF/CNPJ"
              />
            </div>
            <label className="label-gnet-move">
              <div className='div-input'>
                <div className='icono'><i className="fa fa-lg fa-lock" style={{ margin: 'auto', color: '#518AFF' }} /></div>
                <input
                  className='form-control input-gnet gnet-input-move'
                  required={true}
                  disabled={this.state.onLogin}
                  ref={(ref) => {
                    this.passwordInput = ref;
                  }
                  }
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  name="password"
                />
                <span className="gnet-span" id="label-username">SENHA</span>
              </div>
            </label>
            {!this.state.onLogin ?
              <button
                className='btn btn-gnet w-100 font-weight-bold'
                block={!this.parameters.failureRedirect}
                tabIndex={1}
                type="submit"
                name="submit"
                disabled={!this.props.turnstileSuccess}
              >
                {translate('ButtonEnter')}
              </button> :
              <Progress animated color="primary" value={100} className='gnet-progress' />}
            <div className='gnet-error-container'>
              <strong className='gnet-error-msg'>{this.state.error.message} </strong>
            </div>
            <this.props.TurnstileComponent setTurnstileSuccess={this.props.setTurnstileSuccess} />
          </Form>
        </div>
      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true, style: { marginTop: '2rem' } });
